import { styled } from '../../../common/ui'

export const SubTitle = styled.h1`
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #fff;
  margin: 0 0 25px 0;
  padding: 0;
`
